export const EQUICAPITA = 45
export const RICHMON_EQUITY = 91
export const NUMUS_CAPITAL = 94
export const GROSS_CAPITAL = 120
export const WALTON_GLOBAL = 153
export const REGIMEN_EQUITY_PARTNERS = 158
export const CANTIRO_CAPITAL = 211
export const MOSKOWITZ_CAPITAL = 213
export const PRESTIGE_CAPITAL = 217
export const WESTBORO = 216
export const OMNIGENCEASSETMANAGEMENT = 229
export const SIGMA2_FAMILY_OFFICE_INC = 239
export const SHOW_ACCOUNT_BAR_TOTAL_COMPANIES = [249, 250]
